import { Pipe, PipeTransform } from '@angular/core';
import { IConfigNameCase } from './name-case.interface';

@Pipe({
    name: 'nameCase'
})
export class NameCasePipe implements PipeTransform {

    transform(value: string, configs?: IConfigNameCase): string {
        if (value) {
            var ignore = [];
            var foundMatches = value.match(/\w+/g);
            if (configs && configs.ignore && configs.ignore.length) {
                ignore = configs.ignore.map(v => v.toLowerCase());
            }
            for (var x = 0; x < foundMatches.length; x++) {
                var lowerCaseValue = foundMatches[x].toLowerCase();
                if (/^[a-z]/.test(lowerCaseValue) && ignore.indexOf(lowerCaseValue) == -1) {
                    foundMatches[x] = foundMatches[x].toLowerCase().replace(/(^[a-z])/g, function (word) {
                        return word.toUpperCase();
                    });
                }
            }
            return foundMatches.join(" ");
        }

        return value;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/name-case.pipe.ts